// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZmuBr","fullView":"styles_fullView__2sFU1"};